import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '../../store';
import { exitImpersonation } from '../../utils/api';
import { setCredentials } from '../../store/authSlice';

export const ImpersonationBanner: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  if (!user || (!user.impersonatorId && !user.impersonator)) {
    return null;
  }

  const impersonatorName = user.impersonator?.name || user.impersonator?.email || 'Administrator';

  const handleExit = async () => {
    setLoading(true);
    try {
      const res = await exitImpersonation();
      dispatch(setCredentials({ token: res.accessToken }));
      navigate('/admin');
    } catch (err: any) {
      alert(`Failed to exit impersonation session: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: 'linear-gradient(135deg, rgba(234, 179, 8, 0.95) 0%, rgba(202, 138, 4, 0.95) 100%)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(254, 240, 138, 0.5)',
        color: '#000',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 20px rgba(234, 179, 8, 0.3)',

      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '13px', fontWeight: 600 }}>
        <span
          style={{
            background: '#000',
            color: '#eab308',
            padding: '3px 8px',
            borderRadius: '6px',
            fontSize: '11px',
            fontWeight: 800,
            letterSpacing: '0.5px',
          }}
        >
          ⚡ IMPERSONATION SESSION
        </span>
        <span>
          Viewing app as <strong style={{ textDecoration: 'underline' }}>{user.name} ({user.email})</strong>
        </span>
        <span style={{ opacity: 0.8, fontSize: '12px' }}>
          — Logged in as Admin: <strong>{impersonatorName}</strong>
        </span>
      </div>

      <button
        onClick={handleExit}
        disabled={loading}
        style={{
          background: '#000',
          color: '#fff',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          padding: '6px 16px',
          borderRadius: '8px',
          fontSize: '12px',
          fontWeight: 700,
          cursor: loading ? 'wait' : 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <span>{loading ? 'Exiting...' : 'Exit Impersonation ↵'}</span>
      </button>
    </div>
  );
};
